<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Kody GTU</div>
            <div class="text-md text-secondary">Włącz opcję wyboru kodów GTU dla pozycji na fakturach</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <div class="flex items-center space-x-3">
            <mat-slide-toggle 
                color="primary"
                [checked]="enableGTU"
                [disabled]="isProcessing"
                (change)="toggleEnableGTU()">
            </mat-slide-toggle>
            <div class="text-sm text-gray-600 dark:text-gray-400">
                {{enableGTU ? 'Włączone' : 'Wyłączone'}}
            </div>
        </div>
        
        <!-- Informacja o funkcji -->
        <div class="mt-4 text-xs text-gray-500 dark:text-gray-400">
            <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
            Po włączeniu tej opcji, w nowych dokumentach automatycznie będzie dostępna możliwość wyboru kodów GTU dla pozycji.
        </div>
    </div>
</div>
